import { JoyField, JoyObjectType, JoyObject, JoyDataService, isBoolean, isString, isJoyPropertiesArray, compareProps, } from 'joy-core';
export default class JoyPhotosession extends JoyObject {
    /**
     * Create a new JoyPhotosession object.
     * @param data A map of JoyField/value pairs that define the object properties.
     */
    constructor(data) {
        super({
            id: data[JoyField.id],
            objectId: data[JoyField.objectId],
            createdAt: data[JoyField.createdAt],
            createdBy: data[JoyField.createdBy],
        });
        this.fields = [JoyField.name, JoyField.props, JoyField.isPublic, JoyField.description, JoyField.coverMedium];
        this.objectType = JoyObjectType.album;
        this.update = (update) => {
            console.log('new updates for photosession: ' + this.id);
            let changes = [];
            let name = update[JoyField.name];
            if (isString(name) && this._name !== name) {
                this._name = name;
                changes.push(JoyField.name);
            }
            let isPublic = update[JoyField.isPublic];
            if (isBoolean(isPublic) && this._isPublic !== isPublic) {
                this._isPublic = isPublic;
                changes.push(JoyField.isPublic);
            }
            let properties = update[JoyField.props];
            if (isJoyPropertiesArray(properties) && compareProps(this._properties, properties)) {
                this._properties = properties;
                changes.push(JoyField.props);
            }
            let description = update[JoyField.description];
            if (isString(description)) {
                let exists = isString(this._description);
                if (!exists || (exists && this._description !== description)) {
                    this._description = description;
                    changes.push(JoyField.description);
                }
            }
            if (changes.length > 0) {
                super.notifyObservers(changes);
            }
        };
        if (!isString(data[JoyField.group])) {
            return null;
        }
        this.dealId = data[JoyField.group];
        if (!isString(data[JoyField.name])) {
            return null;
        }
        this._name = data[JoyField.name];
        if (!isBoolean(data[JoyField.isPublic])) {
            return null;
        }
        this._isPublic = data[JoyField.isPublic];
        if (!isJoyPropertiesArray(data[JoyField.props])) {
            return null;
        }
        this._properties = data[JoyField.props];
        if (isString(data[JoyField.description])) {
            this._description = data[JoyField.description];
        }
        else {
            this._description = null;
        }
        this.initialUpdate = JoyPhotosession.fields;
        let listenerData = new Map();
        listenerData[JoyField.objectType] = this.objectType;
        listenerData[JoyField.id] = this.id;
        listenerData[JoyField.group] = this.dealId;
        this.listener = JoyDataService.instance.documentListener(listenerData, this.update);
    }
    get name() {
        return this._name;
    }
    get properties() {
        return this._properties;
    }
    get isPublic() {
        return this._isPublic;
    }
    get description() {
        return this._description;
    }
    //Helpers
    /**
     * Set the name field of the document.
     * @param name A string.
     */
    async setName(name) {
        let data = new Map();
        data[JoyField.name] = name;
        data[JoyField.group] = this.dealId;
        return this.updateData(data);
    }
    /**
     * Set the isPublic field of the document.
     * @param isPublic A boolean.
     */
    async setPublic(isPublic) {
        let data = new Map();
        data[JoyField.isPublic] = isPublic;
        data[JoyField.group] = this.dealId;
        return this.updateData(data);
    }
    /**
     * Set the description field of the document.
     * @param description A string.
     */
    async setDescription(description) {
        let data = new Map();
        data[JoyField.description] = description;
        data[JoyField.group] = this.dealId;
        return this.updateData(data);
    }
}
//# sourceMappingURL=JoyPhotosession.js.map